import React from 'react';
import { TextInput, Edit, BooleanInput, SimpleForm } from 'react-admin';
import VmsTypeInput from 'components/VmsTypeInput';
import PositionInput from 'components/PositionInput';

const VmsPositionEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <SimpleForm>
      <VmsTypeInput />
      <PositionInput label="Positions" />
      <TextInput label="VMS Position Label" source="label" />
      <TextInput label="VMS Position Name" source="vms_source_id" />
      <TextInput label="VMS Category Name" source="vms_category_id" />
      <BooleanInput source="active" />
    </SimpleForm>
  </Edit>
);

export default VmsPositionEdit;
